import type { AdminKpisPdfExportButtonProps } from "../../models/admin-kpis.models";
import { DocumentArrowDownIcon } from "@heroicons/react/24/outline";
import { memo } from "react";

const AdminKpisPdfExportButton = ({ disabled, onClick }: AdminKpisPdfExportButtonProps) => {
  return (
    <button
      type="button"
      data-test="admin-kpis-pdf-export"
      disabled={disabled}
      className="inline-flex h-9 items-center gap-2 border border-[#367C2B] bg-white px-2.5 text-sm font-semibold text-[#367C2B] transition-colors hover:bg-[#F2F7F3] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#367C2B] disabled:cursor-not-allowed disabled:opacity-60 dark:bg-gray-900 dark:text-green"
      onClick={onClick}
    >
      <DocumentArrowDownIcon className="h-3.5 w-3.5" aria-hidden="true" />
      PDF Export
    </button>
  );
};

export default memo(AdminKpisPdfExportButton);
